module.exports = __webpack_public_path__ + "static/media/Munna_gaussian2.c294e4d5.png";